import React from "react"
import Lottie from "lottie-react"

import contactAnimation from "./contact.json"

export default function ContactAnimation() {
	return <Lottie animationData={contactAnimation} />
}
